<template>
  <select
    class="role-select"
    :disabled="!position.filled"
    :value="position.possibleRoles.findIndex(role => role.identifier === selectedRole.identifier && role.duty === selectedRole.duty)"
    @change="onRoleChange">
    <option
      v-for="(role, i) in position.possibleRoles"
      :key="position.positionName + role.identifier + role.duty"
      :value="i">
      {{ longName(role) }}
    </option>
  </select>
</template>

<script>
export default {
  props: [
    'position',
    'selectedRole'
  ],

  methods: {
    setRole: function(newRole) {
      this.$store.commit("setRole", {
        position: "player"+this.position.positionNumber,
        role: newRole
      });
    },

    onRoleChange(event) {
      this.setRole(this.position.possibleRoles[event.target.value])
      this.$emit("change:role", {
        position: this.position.positionNumber,
        role: event.target.value,
      })
    },

    longName(role) {
      const roleName = this.$t(`roles.${role.identifier.toLowerCase()}`);
      const dutyName = this.$t(`duties.${role.duty.toLowerCase()}`);
      return `${roleName} (${dutyName})`;
    },
  }
}
</script>

<style scoped>
  .role-select {
    opacity: 0;
    position: absolute;
    left: 0;
    right: 0;
    cursor: pointer;
  }
</style>
